import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import { PageWrapper } from 'src/routes/guards/UserProfileGuard';

const CommonError = () => {
  return (
    <PageWrapper>
      <>
        <Box>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary">
            An unexpected error occurred on our end. Please try again later, or contact support for assistance.
          </Typography>
        </Box>

        <Box>
          <img src="/images/illustration_server_error.png" alt="Server error" style={{ padding: '40px 67px 80px' }} />
          <Button
            component={RouterLink}
            target="_blank"
            to={`https://receiveddigital.com/help-center/contact-support/`}
            size="large"
            variant="contained"
            color="primary"
          >
            Contact Support
          </Button>
        </Box>
      </>
    </PageWrapper>
  );
};

export default CommonError;
